const data = {
  id: 1,
  title: 'Listen and choose the word with the different middle sound.',
  subTitle: 'Nghe và chọn từ có âm giữa khác với các từ còn lại.',
  question: '',
  answers: [
    { id: 1, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/f1ef1841-c2cf-43ce-b058-00e315748e29.mp3' },
    { id: 2, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/cc80fa9f-8dae-4faf-a7ce-7b1e9ec996dd.mp3' },
    { id: 3, answer: '', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/defe7a3f-7497-4fcb-ab89-2587fa86f6ff.mp3' },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
